import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Loading from '../../../components/Loading'
import Section from '../../../components/Section'
import { getDetail } from '../../../api/major'
import './index.less'
import img_code from '../../../assets/svg/img_code.png'
import img_name from '../../../assets/svg/img_name.png'
import img_lengthTime from '../../../assets/svg/img_lengthtime.png'
import {COLOR_LIST} from "../../constants";
class MajorDetail extends Component {

  static propTypes = {
    renderOperationBtn: PropTypes.func,
    onBack: PropTypes.func,
  }

  state = {
    id: this.props.match.params.id,
    detail: null,
    loading: false,
  }

  componentDidMount() {
    const { match } = this.props
    this.getDetail(match.params.id)
  }

  getDetail(id) {
    this.setState({ loading: true })
    getDetail(id).then(({ data }) => {
      let div = document.createElement('div')
      let description
      div.innerHTML = data.introduction
      description = div.innerText.match(/^.*?。/)
      data.description = description ? description[0] : div.innerText
        let sexArr=data.sexRatio ? data.sexRatio.split(':') : [];
        let liWenArr=data.natSocRatio ? data.natSocRatio.split(':') : [];
        if(sexArr.length>0){
             data.numBoy=sexArr[0];
             data.numGirl=sexArr[1];
        }
        if(liWenArr.length>0){
             data.numLi=liWenArr[1];
             data.numWen=liWenArr[0];
        }
      this.setState(() => ({
        detail: data,
        loading: false,
      }))
    }).finally(() => {
      this.setState({ loading: false })
    })
  }

  handleRecommendationClick(profession) {
    const { history, onRecommendationClick } = this.props
    typeof onRecommendationClick === 'function'
      ? onRecommendationClick(profession)
      : history.push(`/profession/detail/${profession.id}`)
  }

  handleBack(major) {
    const { history, onBack } = this.props
    typeof onBack === 'function'
      ? onBack(major)
      : history.push(`/major/list/undergraduate`);
  }
  handleBackToHome(){

  }
  dealBgName=(name)=>{
    switch(name){
        case '经济学': return 'jingjixue'; break;
        case '法学': return 'faxue'; break;
        case '工学': return 'gongxue'; break;
        case '管理学': return 'guanlixue'; break;
        case '教育学': return 'jiaoyuxue'; break;
        case '理学': return 'lixue'; break;
        case '农学': return 'nongxue'; break;
        case '文学': return 'wenxue'; break;
        case '艺术学': return 'yishuxue'; break;
        case '医学': return 'yixue'; break;
        case '哲学': return 'lixue'; break;
        case '历史学': return 'wenxue'; break;
        default : return 'nongxue';
    }
  };
  render() {
    const { detail, loading } = this.state
    const { renderOperationBtn } = this.props
    if (loading) {
      return (
        <div className="major-detail">
          <Loading />
        </div>
      )
    } else {
      if (detail === null) {
        return (
          <div className="major-detail">
            <div>没有对应的专业</div>
          </div>
        )
      } else {
          let bgName=detail.category.name && this.dealBgName(detail.category.name);
          return (
          <div className="major-detail">
              <div className={`detail-banner ${bgName}`}>
                  <div className='title-and-add-box'>
                      <h1>{detail.name}</h1>
                  </div>
                  <p className='tips'>{detail.type==20?'本科':'专科'} > {detail.category.name} > {detail.classify.name}</p>
                  <div className="property">
                      <div className='property-item'>
                          <div className='name'><img src={img_code} alt=""/></div>
                          <div className='line'></div>
                          <div className='code'>{detail.code?detail.code:"-"}</div>
                      </div>
                      <div className='property-item degreeName' >
                          <div className='name'><img src={img_name} alt=""/></div>
                          <div className='line'></div>
                          <div className='code'>{detail.degree.name?detail.degree.name:'-'}</div>
                      </div>
                      <div className='property-item' style={{border:'none'}}>
                          <div className='name'><img src={img_lengthTime} alt=""/></div>
                          <div className='line'></div>
                          <div className='code'>{detail.lengthTime?detail.lengthTime:'-'}</div>
                      </div>
                  </div>
              </div>
              <Section title={'专业介绍'}>
                  <div className="explanation" dangerouslySetInnerHTML={{ __html: detail.introduction?detail.introduction:'暂无数据' }}></div>
                  <h2 className='proportion-title'>比例信息</h2>
                  <div className='proportion-info'>
                      {detail.numGirl ?
                          <div className='info-item'>
                              <div className="head head-boy"></div>
                              <div className="center-box">
                                  <div className="line ">
                                      <div className="line-right line-right-gender " style={{width:`${detail.numGirl}%`}}></div>
                                  </div>
                                  <div className='num-box' >
                                      <span className='num-left'>男&nbsp;{detail.numBoy}%</span>
                                      <span className='num-right'>{detail.numGirl}%&nbsp;女</span>
                                  </div>
                              </div>
                              <div className="head head-girl"></div>
                          </div>
                          :
                          <div className='info-item'>
                              <div className="head head-no-boy"></div>
                              <div className="center-box">
                                  <div className="line no-line ">
                                      <div className="line-right line-right-gender " style={{width:`${detail.numGirl}%`}}></div>
                                  </div>
                                  <div className='num-box' >
                                      <span className='no-num'>暂无男女比例数据</span>
                                  </div>
                              </div>
                              <div className="head head-no-girl"></div>
                          </div>
                      }
                      {detail.numLi ?
                          <div className='info-item' style={{margin:0}}>
                              <div className="head head-li"></div>
                              <div className="center-box">
                                  <div className="line">
                                      <div className="line-right line-right-major" style={{width:`${detail.numWen}%`}}></div>
                                  </div>
                                  <div className='num-box' >
                                      <span className='num-left'>理科&nbsp;{detail.numLi}%</span>
                                      <span className='num-wen'>{detail.numWen}%&nbsp;文科</span>
                                  </div>
                              </div>
                              <div className="head head-wen"></div>
                          </div>
                          :
                          <div className='info-item' style={{margin:0}}>
                              <div className="head head-no-li"></div>
                              <div className="center-box">
                                  <div className="line no-line">
                                      <div className="line-right line-right-major" style={{width:`${detail.numWen}%`}}></div>
                                  </div>
                                  <div className='num-box' >
                                      <span className='no-num'>暂无文理比例数据</span>
                                  </div>
                              </div>
                              <div className="head head-no-wen"></div>
                          </div>
                      }
                  </div>
              </Section>
              <Section title='专业培养'>
                  <h2 className='trainTarget-title'>培养目标</h2>
                  <div className="competence" dangerouslySetInnerHTML={{ __html: detail.trainTarget?detail.trainTarget:'暂无数据' }}></div>
                  <h2 className='trainTarget-title'>培养要求</h2>
                  <div className="competence" dangerouslySetInnerHTML={{ __html: detail.courseReq?detail.courseReq:'暂无数据' }}></div>
              </Section>
              <Section title='专业能力'>
                  <div className="competence" dangerouslySetInnerHTML={{ __html: detail.ability? detail.ability:'暂无数据' }}></div>
              </Section>
              <Section title="主要课程">
                  <div className="courses" dangerouslySetInnerHTML={{ __html: detail.openCourses? detail.openCourses:'暂无数据' }}></div>
              </Section>
              <Section title="发展路径" className='develop'>
                  <div className="job-orientation" >
                      <div className="title">考研方向</div>
                      <div dangerouslySetInnerHTML={{__html: detail.masterDirect?detail.masterDirect:'暂无数据'}}></div>
                  </div>
                  <div className="slash"></div>
                  <div className="job-orientation" style={{margin:0}}>
                      <div className="title">就业方向</div>
                      <div dangerouslySetInnerHTML={{ __html: detail.jobOrientation?detail.jobOrientation:'暂无数据' }}></div>
                  </div>
                  <div className="slash" style={{margin:0}}></div>
              </Section>
              <Section title="社会名人" >
                  <div className="job-orientation" dangerouslySetInnerHTML={{ __html: detail.celebrities?detail.celebrities:'暂无数据' }}></div>
              </Section>
            {Array.isArray(detail.recommendJobs) && detail.recommendJobs.length
              ?
                <Section title="推荐职业">
                    <div className="recommendations">
                      <p>我们猜你可能会对这些职业感兴趣：</p>
                      {detail.recommendJobs.map((d, i) =>
                        <div
                          key={i}
                          className="recommendation-card"
                          onClick={this.handleRecommendationClick.bind(this, d)}
                          style={{ backgroundColor: COLOR_LIST[i % COLOR_LIST.length] }}>
                          <h3>{d.name}</h3>
                          <p>点击了解这个职业</p>
                        </div>
                      )}
                        {this.props.hideBottomBtn?
                            null
                            :
                            <button onClick={this.handleBack.bind(this, detail)}>返回专业列表</button>
                        }
                    </div>
                </Section>
              :
                this.props.hideBottomBtn?
                    null
                    :
                    <Section>
                        <div className="recommendations">
                            <button onClick={this.handleBack.bind(this, detail)}>返回专业列表</button>
                        </div>
                        {/*<div className="recommendations">*/}
                        {/*<button onClick={this.handleBackToHome.bind(this)}>返回系统首页</button>*/}
                        {/*</div>*/}
                    </Section>
            }
              {renderOperationBtn(detail)}
              {/* <div className="further-reading">
              <h4>{detail.name}·拓展阅读</h4>
              <div className="further-reading-card">
                <h5>学金融数学要很好？</h5>
                <p>金融专业就业去向广泛，既有工作稳定福利待遇好的商业银行，也有压力较大但相对多金的投资银行、证券公司金融专业就业去向广泛金融专业就业去向广泛，既有工作稳，金融专业就业去向广泛，既有工作稳定福利待遇好的商业银行，也有压力较大但相对多金的投资银行、证券公司金融专业就业去向广泛金融专业就业去向广泛，既有工作稳</p>
                <a href="">继续阅读 &gt;</a>
              </div>
            </div> */}

          </div>
        )
      }
    }
  }
}

MajorDetail.defaultProps = {
  renderOperationBtn: () => null,
}

export default MajorDetail



// WEBPACK FOOTER //
// ./src/pages/Major/Detail/index.js